"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'renewRecord',
  components: {
    Pagination: _Pagination.default,
    drawer: _filter.default
  },
  data: function data() {
    return {
      fee_type: ['平台使用合同', '微信广告开通'],
      date_type: ['永久', '年付', '月付'],
      form: {},
      list: [],
      listLoading: true,
      listQuery: {
        renew_fee_type: '-1',
        search_contract_type: '-1',
        search_contract_status: '-1',
        start: 1,
        total: 10,
        limit: 20,
        page_num: 1
      }
    };
  },
  mounted: function mounted(options) {
    this.getList();
  },
  methods: {
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) {
        this.form = {};
        this.listQuery.start = 1;
      } else {
        this.listQuery.start = 1;
      }
      this.getList();
    },
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this = this;
      var listQuery = Object.assign({}, this.form, this.listQuery, {
          start: this.listQuery.start - 1
        }),
        url = 'agentapi/pay/contract_pay_log';
      this.$get(url, listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.stat_data = res.stat_data;
        _this.listQuery.page_num = res.page_num;
      }).catch(function () {
        _this.listLoading = false;
      });
    }
  }
};